import {
  Link,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import PaginationLayout from "../components/PaginationLayout";
import Button from "react-bootstrap/Button";
// import placeholder from "../assets/images/profile_placeholder.png"
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
// import Swal from "sweetalert2";
import { getUserProfileImage } from "../utils/constant_value";
function Reels() {
  const [Coin, setCoin] = useState(false);
  const handleCloseCoin = () => setCoin(false);

  const [like, setLike] = useState(false);
  const [comment, setComment] = useState(false);
  const [loading, setLoading] = useState(false)
  // Video one stop if another play
  var videoPlaying = null;
  const onPlay = function () {
    if (videoPlaying && videoPlaying != this) {
      videoPlaying.pause();
    }
    videoPlaying = this;
  };
  const videos = document.getElementsByClassName("video-bg");
  for (let i = 0; i < videos.length; i++) {
    videos[i].addEventListener("play", onPlay);
  }
  // const [reels, setReels] = useState(AllVideos);
  const param = useParams();

  const location = useLocation();
  const match = useMatch("/reels/:page");
  // const navigate = useNavigate();
  var query = new URLSearchParams(location.search);
  let limit = 9;
  const {
    authState,
    staticDataState,
    handleError,
    handlePagination, handleFilter,
    scrollToTop,
  } = useContext(GlobalContext);
  const nfts = staticDataState.nfts;

  henceforthApi.setToken(authState.access_token);
  const [ReelsData, setReelsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const fetchReels = async () => {
    try {
      setLoading(true)
      let q = query.toString();
      const ReelRes = await henceforthApi.Reels.pagination(
        q,
        Number(param.page) - 1,
        limit
      );
      setLoading(false)
      setTotalCount(ReelRes.count);
      setReelsData(ReelRes.reels);
    } catch (error) {
      handleError(error)
    }

  };
  const [manageMedias, setManageMedias] = useState({
    type: "",
    _id: "",
    admin_verified: false,
    language: "ENGLISH",
    account_status: "",
  });

  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState([])
  const initialiseLightBox = (data) => {
    setPhotoIndex(0)
    setIsOpen(true)
    setLightboxImages(data)
  }

  //Filter

  var query = new URLSearchParams(location.search);
  const filters = [
    { name: "Live", value: "Live" },
    { name: "Deleted", value: "Deleted" },
    { name: "Activated", value: "Activated" },
    { name: "Deactivated", value: "Deactivated" }
  ];
  // const onFilterApply = (name, value) => {
  //   if (query.has(name)) {
  //     let queryValue = query.get(name);
  //     // if (queryValue == value) {
  //     if (value === "") {
  //       query.delete(name);
  //     } else {
  //       query.set(name, value);
  //     }
  //   } else {
  //     query.set(name, value);
  //   }
  //   navigate({ pathname: `/reels/1`, search: query.toString() }, { replace: true });
  // };

  //Coins
  const [getCoins, setGetCoins] = useState([]);
  const [totalCoins, setGetTotalCoins] = useState({});
  const HandleCoins = async (Coin) => {
    // setCoin(true);
    try {
      const CoinsResponse = await henceforthApi.Posts.coins(Coin);
      setGetCoins(CoinsResponse);
      setGetTotalCoins(CoinsResponse);
    } catch (error) {
      // console.log("Coins Error", error);
    }
  };
  // console.log("CoinsResponse", getCoins);

  //Like
  const [getLike, setGetLike] = useState([]);
  const HandleLike = async (like) => {
    // setLike(true);
    try {
      const likeResponse = await henceforthApi.Posts.like(like);
      setGetLike(likeResponse);
    } catch (error) {
    }
  };
  //Comment
  const [getComment, setGetComment] = useState([]);
  const HandleComment = async (LC) => {
    // setComment(true);
    try {
      const CommentResponse = await henceforthApi.Posts.Comment(LC);
      setGetComment(CommentResponse);
    } catch (error) {
    }
  };

  //Remove
  const [showRemove, setShowRemove] = useState(false);
  // const handleConfirm = (id) => {
  //   console.log(id);
  //   setShowRemove(id);
  // }
  const handleRemove = async (id) => {
    try {
      await henceforthApi.Reels.delete(id);
      setShowRemove(false);
      fetchReels();
    } catch (Error) {
    }
    setShowRemove(false)
  };
  useEffect(() => {
    fetchReels();
    scrollToTop();
  }, [param.page, query.get("filter"), manageMedias]);

  return (
    <>
      <div class="row animated fadeInRight">
        <div class="col-md-12">
          <div>
            {isOpen && <Lightbox
              mainSrc={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${lightboxImages[photoIndex].media_url}`}
              nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
              prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % lightboxImages.length)
              }
            />}
          </div>
          <div className="ibox">
            <div className="ibox-title d-flex align-items-center justify-content-between">
              <div className="dropdown theme me-3">
                <button
                  className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
                  id="sortDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {filters.filter((res) => res.value == query.get("filter"))
                    .length
                    ? filters.filter(
                      (res) => res.value === query.get("filter")
                    )[0].name
                    : "All"}
                  {/* <i
                className="fas fa-chevron-down bi-chevron-down ms-2 "
                style={{ fontSize: "12px" }}
              ></i> */}
                </button>
                <ul
                  className="dropdown-menu share-icons"
                  aria-labelledby="sortDropdown"
                >
                  {query.has("filter") && (
                    <li className="cursor-pointer">
                      <a
                        className="dropdown-item"
                        onClick={() => handleFilter("filter", "")}
                      >
                        All
                      </a>
                    </li>
                  )}
                  {filters.map((res) => {
                    return (
                      <li key={res.value} className="cursor-pointer">
                        <a
                          className="dropdown-item"
                          onClick={() => handleFilter("filter", res.value)}
                        >
                          {res.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="ibox-content">
              <div>
                <div className="row">
                  {!loading && !ReelsData?.length ? <div className="text-center"> <b>No Reels Found </b> </div> : ReelsData.map((item, index) => (
                    <div class="col-md-6 col-lg-4 mb-4" key={index}>

                      <div class="card mb-4 box-shadow border-0 shadow h-100">
                        <Link to="">
                          {item?.post_medias.length ?
                            item?.post_medias.map((res, index) => (
                              <div className="explore-img" key={index}>
                                <video
                                  id="videos"
                                  class="video-bg"
                                  src={`https://shadowzapp.sgp1.digitaloceanspaces.com/shadowzapp/video/${res.media_url}`}
                                  autostart
                                  controls
                                  muted
                                  controlsList="nodownload"
                                />
                              </div>
                            )) : <img src={profile_placeholder} />}
                        </Link>
                        {/* <Link to={`/media/${item?._id}`} className=""   style={{ textDecoration: "none" }}> */}
                        <div class="card-body">
                          {/* <h2 className="fw-bolder" >{name}</h2> */}

                          <div className="username-box my-1 d-flex justify-content-between align-items-center">
                            <div className="d-flex gap-1 ProfileImagePRS-box">
                              <img className="ProfileImagePRS" src={getUserProfileImage(item?.profile_pic)} alt=""
                                onClick={() => initialiseLightBox(item?.post_medias)}
                              />
                              <Link
                                to={`/user/${item?.user_id}/2/1?type=reels`}
                                className="Details_of_User"
                              >
                                <p className="fw-bolder m-0" style={{ fontSize: "14px" }}>
                                  {item?.name}
                                </p>
                              </Link >
                            </div>
                            <div>
                              <label className="PublicPrivate">
                                <i
                                  class={item?.is_private == false ?
                                    `fas fa-globe-africa` : `fas fa-lock`}
                                  style={{ marginRight: "3px" }}
                                ></i>
                                {item?.is_private == false
                                  ? "Public"
                                  : "Private"}
                              </label>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-6">
                              <div className="desc-box" style={{ minHeight: "45px" }}>
                                <p className="m-0" style={{ fontSize: "14px" }}>
                                  <b>Description:</b>{" "}
                                  <span>{item.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="text-end">
                                <label className={item.status == "Active" ? "custom-status" : "custom-status-deactivate"}>
                                  {item.status}
                                </label>
                              </div>
                            </div>
                          </div>
                          {/* <div className="both-added mt-3">
                            <div className="">
                              <div className="fw-bolder">
                                <h6
                                  onClick={() => HandleCoins(item._id)}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "14px",
                                  }}
                                >
                                  {" "}
                                  Coin:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    <i
                                      style={{
                                        marginRight: "2px",
                                        fontSize: "17px",
                                      }}
                                      class="fas fa-usd-circle"
                                    ></i>
                                    {item.coins_count}
                                  </span>
                                </h6>
                                <h6
                                  className="SongsDiv"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "14px",
                                  }}
                                >
                                  {" "}
                                  Song Name:
                                  <span
                                    className="Songs_Reels"
                                    style={{
                                      fontWeight: "bold",
                                      marginLeft: "3px",
                                      fontSize: "12px !important",
                                      color: "e5e5e5",
                                    }}
                                  >
                                    {item.song_name}
                                  </span>
                                </h6>
                              </div>
                              <p className="fw-bolder">Lorem Ipsum</p>
                            </div>
                          </div> */}
                          <div className="brown-text text-wrap">
                              {/* <h2 >{moment(Number(created_at)).format("MMM DD, YYYY")}</h2> */}
                              <div
                                style={{ cursor: "pointer" }}
                                className="fw-bolder text-end d-flex gap-3 justify-content-between"
                              >
                                <h6
                                  style={{ fontSize: "14px" }}
                                  onClick={() => HandleComment(item._id)}
                                >
                                  Comments:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "14px ",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    {item.comments_count}
                                  </span>
                                </h6>
                                <h6
                                  style={{ fontSize: "14px" }}
                                  onClick={() => HandleLike(item._id)}
                                >
                                  Likes:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    {item.likes_count}
                                  </span>
                                </h6>
                              </div>
                            </div>
                          <hr />
                          <div className="row align-items-center">
                            <div className="col-6">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="btn-group">
                                  <div className="bown-num ">
                                    <p className="m-0">
                                      {" "}
                                      <small style={{ whiteSpace: "" }}>
                                        {moment(Number(item.created_at)).format(
                                          "DD MMM YYYY, h:mm a"
                                        )}
                                      </small>{" "}
                                    </p>
                                  </div>{" "}
                                  <div className="bown-num"></div>

                                </div>
                              </div>
                            </div>

                            {/* {item.is_removed == true ? (
                              " "
                            ) : ( */}
                            <div className="col-6">
                              <div className="text-end">
                                <Link to={`/media/${item._id}/like`}>
                                  <div className="">
                                    <button
                                      style={{ float: "right" }}
                                      className="btn mt-2 btn-outline-dark"
                                    >
                                      Details
                                    </button>
                                  </div>
                                </Link>
                              </div>
                              {/* <button
                                onClick={() => handleActivate(item?._id,item?.status)}
                                style={{ float: "right" }}
                                className="btn btn-danger"
                              >
                               {item?.status == "Active" ? "Active":  "Deactive" } 
                              </button> */}
                            </div>
                            {/* )} */}
                            {/* Remove modal */}
                            <Modal
                              show={showRemove}
                              onHide={() => setShowRemove(false)}
                              backdrop="static"
                              keyboard={false}
                              centered
                              scrollable

                              className="confirm-box-modal"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Remove
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="my-3 text-center">
                                  Do you want to Remove?
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button onClick={() => setShowRemove(false)} className="px-6 confirm-btn">
                                  No
                                </Button>
                                <Button onClick={() => handleRemove(showRemove)} className="px-6 confirm-btn">
                                  Yes
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </div>
                        {/* </Link> */}
                      </div>

                    </div>
                  ))}
                </div>
                <div>
                  {/* Coins */}
                  <Modal
                    show={Coin}
                    onHide={handleCloseCoin}
                    centered
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        <Link
                          to=""
                          style={{
                            textDecoration: "none",
                            color: "#000000",
                            cursor: "auto",
                          }}
                        >
                          Coins
                        </Link>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        {getCoins?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Coins</div> : getCoins?.data?.map((item, index) => (
                          <div className="col-sm-12 ">
                            <div
                              className="image-name-box d-flex gap-2 align-items-right justify-content-between px-3"
                              key={index}
                            >
                              <div className="d-flex gap-2 align-items-center">
                                <div className="image-box">
                                  <img
                                    src={getUserProfileImage(item?.users?.profile_pic)}
                                    alt="ProfileImage"
                                    class="modal-profile"
                                  />
                                </div>

                                <div className="name-box">
                                  <Link
                                    to={`/user/${item.users?._id}/1/1?type=posts`}
                                    className="Details_of_User"
                                  >
                                    <p className="mb-0 profile-name">
                                      {item?.users?.full_name}
                                    </p>
                                  </Link>
                                  <div>
                                    <p
                                      className="m-0"
                                      style={{
                                        fontSize: "10px",
                                      }}
                                    >
                                      {moment(
                                        Number(item?.users?.created_at)
                                      ).format("DD MMM YYYY, h:mm a")}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="image-name-box">
                                <p>
                                  <i
                                    style={{ marginRight: "2px" }}
                                    class="fas fa-usd-circle"
                                  ></i>
                                  {item?.coins}
                                </p>
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                        {totalCoins?.coins_count == 0 ? " " :
                          <>
                            <div className="col-sm-8 d-flex gap-2 align-items-center">
                              <h6 style={{ fontWeight: "bold" }} className="ps-3">
                                Total Received :
                              </h6>
                            </div>
                            <div className="col-sm-4">
                              <dt className="text-end pe-3">
                                <i
                                  style={{ marginRight: "2px" }}
                                  class="fas fa-usd-circle"
                                ></i>
                                {totalCoins?.coins_count}
                              </dt>
                            </div>
                          </>
                        }
                      </div>
                    </Modal.Body>
                  </Modal>
                  {/* like */}
                  <Modal
                    show={like}
                    onHide={() => setLike(false)}
                    centered
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Likes
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {getLike?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Likes</div> : getLike?.data?.map((item, index) => (
                        <>
                          <div
                            className="modal-wrapper d-flex align-items-center  mx-2"
                            key={index}
                          >
                            <img
                              src={getUserProfileImage(item?.profile_pic)}
                              alt="ProfileImage"
                              class="modal-profile me-2"
                            />
                            <Link
                              to={`/user/${item?.user_id}/1/1?type=posts`}
                              className="Details_of_User"
                            >
                              <p className="mb-0 profile-name">{item.name}</p>
                            </Link>
                          </div>
                          < hr />
                        </>
                      ))}


                    </Modal.Body>
                  </Modal>
                  {/* Comment */}
                  <Modal
                    show={comment}
                    onHide={() => setComment(false)}
                    centered
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Comments
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {getComment?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Comments</div> : getComment?.data?.map((item, index) => (
                        <>
                          <div
                            className="image-name-box d-flex gap-2 align-items-start w-100"
                            key={index}
                          >
                            <div className="image-box">
                              <img
                                src={getUserProfileImage(item?.profile_pic)}
                                alt="ProfileImage"
                                class="modal-profile align-items-start"
                              />
                            </div>

                            <div className="name-box w-100">
                              <div className="d-flex align-items-center justify-content-between ">
                                <div>
                                  <Link
                                    to={`/user/${item?.user_id}/1/1?type=posts`}
                                    className="Details_of_User"
                                  >
                                    <p className="mb-0 profile-name">
                                      {item.name}
                                    </p>
                                  </Link>
                                </div>
                                <div className="">
                                  <p
                                    className="m-0"
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {moment(Number(item.created_at)).format(
                                      "DD MMM YYYY, h:mm a"
                                    )}
                                  </p>
                                </div>
                              </div>
                              <p
                                className="m-0"
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {item.comments}
                              </p>
                            </div>
                          </div>
                          <hr />
                        </>
                      ))}
                    </Modal.Body>
                  </Modal>
                </div>
              </div>

              <PaginationLayout
                count={totalCount}
                data={ReelsData}
                page={Number(param.page)}
                limit={Number(limit)}
                loading={loading}
                onPageChange={(val) => handlePagination(val)}
              />
            </div>
          </div>
        </div >
      </div >
    </>
  );
}

export default Reels;
